import analyticsPubSub, { ANALYTICS_EVENTS } from "../analyticsPubSub";
import mixpanel from "mixpanel-browser";

// const INTERNAL_MIX_PANEL_TOKEN = `093dd94ada4364eff06e76b5eb63ed0a`;

const MIX_PANEL_EVENTS = [
  ANALYTICS_EVENTS.APP_LAUNCHED,
  ANALYTICS_EVENTS.DELIVERY_STORE_SELECTED,
  ANALYTICS_EVENTS.NO_STORES_NEARBY,
  ANALYTICS_EVENTS.NEAREST_STORE_CLOSED_TEMP,
  ANALYTICS_EVENTS.NEAREST_STORE_CLOSED_TODAY,
  ANALYTICS_EVENTS.ITEM_SEARCH,
  ANALYTICS_EVENTS.REORDER,
  ANALYTICS_EVENTS.COUPON_SUCCESS,
  ANALYTICS_EVENTS.COUPON_FAILED,
  ANALYTICS_EVENTS.LOGIN_SUCCESS,
  ANALYTICS_EVENTS.LOGIN_FAILED,
  ANALYTICS_EVENTS.PASSWORD_RESET,
  ANALYTICS_EVENTS.RESEND_OTP,
  ANALYTICS_EVENTS.SIGNUP_START,
  ANALYTICS_EVENTS.SIGNUP_COMPLETE,
  ANALYTICS_EVENTS.SOCIAL_LOGIN_SIGNUP_START,
  ANALYTICS_EVENTS.SOCIAL_LOGIN_SIGNUP_COMPLETE,
  ANALYTICS_EVENTS.SOCIAL_LOGIN_SUCCESS,
  ANALYTICS_EVENTS.SOCIAL_LOGIN_FAILED,
  ANALYTICS_EVENTS.WALLET_RELOAD_INIT,
  ANALYTICS_EVENTS.SUCCESSFUL_WALLET_RELOAD,
  ANALYTICS_EVENTS.FAILED_WALLET_RELOAD,
  ANALYTICS_EVENTS.REFERRAL_SENT,
  ANALYTICS_EVENTS.LOGOUT,
  ANALYTICS_EVENTS.PRODUCT_CLICKED,
  ANALYTICS_EVENTS.CART_INIT,
  ANALYTICS_EVENTS.ADD_TO_CART,
  ANALYTICS_EVENTS.REMOVE_FROM_CART,
  ANALYTICS_EVENTS.VIEW_CART,
  ANALYTICS_EVENTS.ORDER_PLACED,
  ANALYTICS_EVENTS.ITEM_LIKED,
  ANALYTICS_EVENTS.ITEM_UNLIKED,
  ANALYTICS_EVENTS.FEEDBACK_SUBMITTED,
  ANALYTICS_EVENTS.CHECKOUT_INIT,
  ANALYTICS_EVENTS.PROFILE_UPDATED,
  ANALYTICS_EVENTS.BANNER_CLICKED,
  ANALYTICS_EVENTS.ADDRESS_SELECTED,
  ANALYTICS_EVENTS.LANDING_SCREEN_OPEN,
  ANALYTICS_EVENTS.PICKUP_STORE_SELECTED,
  ANALYTICS_EVENTS.MULTIPLE_DELIVERY_STORES,
  ANALYTICS_EVENTS.FILTER_APPLIED,
  ANALYTICS_EVENTS.SORT_APPLIED,
  ANALYTICS_EVENTS.ADD_MORE_ITEMS,
  ANALYTICS_EVENTS.VIEW_MORE_DESC,
  ANALYTICS_EVENTS.SELECTED_PAYMENT_MODE,
  ANALYTICS_EVENTS.SELECTED_DELIVERY_ADDRESS,
  ANALYTICS_EVENTS.ADD_MONEY_CHECKOUT,
  ANALYTICS_EVENTS.CATEGORY_DETAIL,
];

let selected_tokens = [];

function init(tokens, config = {}, env) {
  if (env === "production" && window?.location?.hostname !== "localhost") {
    //   selected_tokens = [INTERNAL_MIX_PANEL_TOKEN];
  }

  // Check if mixpanelRandomValue is already present in localStorage
  const storedRandomValue = localStorage.getItem("mixpanelRandomValue");

  let randomValue;

  if (storedRandomValue) {
    randomValue = parseFloat(storedRandomValue);
  } else {
    randomValue = Math.random();
    localStorage.setItem("mixpanelRandomValue", randomValue);
  }

  if (tokens && tokens?.length > 0) {
    const samplingRate = 0.05; // track only 5% of users;

    if (randomValue < samplingRate && selected_tokens?.length > 0) {
      selected_tokens = [...selected_tokens, ...tokens];
    } else {
      selected_tokens = [...tokens];
    }
  }

  selected_tokens.forEach((token) => {
    mixpanel.init(token, {}, token);
    mixpanel[token].register(config);

    // to store a super property only once
    // ref : https://docs.mixpanel.com/docs/tracking/reference/javascript#setting-super-properties-only-once
    mixpanel[token].register_once({
      platform: "web",
      theme: window.ROOT_CONFIG.theme.name,
      biz_name: config?.biz_name,
      biz_id: config?.biz_id,
    });
  });

  return subscribe();
}

function subscribe() {
  const handlers = [];

  MIX_PANEL_EVENTS.forEach((event) => {
    const handleFunction = (response) => {
      handleEvent(event, response);
    };

    analyticsPubSub.subscribe(event, handleFunction);

    handlers.push({ event, handler: handleFunction });
  });

  return handlers;
}

function unsubscribe(handlers) {
  handlers.forEach(({ event, handler }) => {
    analyticsPubSub.unsubscribe(event, handler);
  });
}

function handleEvent(type, data) {
  let eventName = "";
  switch (type) {
    case ANALYTICS_EVENTS.APP_LAUNCHED:
      eventName = "ppr-app-launched";
      break;
    case ANALYTICS_EVENTS.DELIVERY_STORE_SELECTED:
      eventName = "ppr-delivery-store-selected";
      break;
    // case ANALYTICS_EVENTS.NO_STORES_NEARBY:
    //   eventName = "ppr-no-stores-nearby";
    //   break;
    // case ANALYTICS_EVENTS.NEAREST_STORE_CLOSED_TEMP:
    //   eventName = "ppr-nearest-store-closed-temp";
    //   break;
    case ANALYTICS_EVENTS.NEAREST_STORE_CLOSED_TODAY:
      eventName = "ppr-nearest-store-closed";
      break;
    case ANALYTICS_EVENTS.ITEM_SEARCH:
      eventName = "ppr-item-search";
      break;
    case ANALYTICS_EVENTS.REORDER:
      eventName = "ppr-reorder-init";
      break;
    case ANALYTICS_EVENTS.COUPON_SUCCESS:
      eventName = "ppr-coupon-applied";
      break;
    case ANALYTICS_EVENTS.COUPON_FAILED:
      eventName = "ppr-coupon-applied";
      break;
    case ANALYTICS_EVENTS.LOGIN_SUCCESS:
      eventName = "ppr-login";
      setMixpanelIdentity(data);
      break;
    case ANALYTICS_EVENTS.LOGIN_FAILED:
      eventName = "ppr-login";
      break;
    case ANALYTICS_EVENTS.PASSWORD_RESET:
      eventName = "ppr-password-reset";
      break;
    case ANALYTICS_EVENTS.RESEND_OTP:
      eventName = "ppr-resend-otp";
      break;
    case ANALYTICS_EVENTS.SIGNUP_START:
      eventName = "ppr-signup-start";
      break;
    case ANALYTICS_EVENTS.SIGNUP_COMPLETE:
      eventName = "ppr-signup-complete";
      break;
    case ANALYTICS_EVENTS.SOCIAL_LOGIN_SIGNUP_START:
      eventName = "ppr-signup-start";
      break;
    case ANALYTICS_EVENTS.SOCIAL_LOGIN_SIGNUP_COMPLETE:
      eventName = "ppr-signup-complete";
      break;
    case ANALYTICS_EVENTS.SOCIAL_LOGIN_SUCCESS:
      eventName = "ppr-login";
      // setMixpanelIdentity(data)
      break;
    case ANALYTICS_EVENTS.SOCIAL_LOGIN_FAILED:
      eventName = "ppr-login";
      break;
    // case ANALYTICS_EVENTS.WALLET_RELOAD_INIT:
    //   eventName = "ppr-wallet-reload-init";
    //   break;
    case ANALYTICS_EVENTS.SUCCESSFUL_WALLET_RELOAD:
      eventName = "ppr-wallet-reload-complete";
      break;
    case ANALYTICS_EVENTS.FAILED_WALLET_RELOAD:
      eventName = "ppr-wallet-reload-complete";
      break;
    case ANALYTICS_EVENTS.REFERRAL_SENT:
      eventName = "ppr-referral-sent";
      break;
    // case ANALYTICS_EVENTS.LOGOUT:
    //   eventName = "ppr-logout";
    //   resetIdentity();
    //   break;
    case ANALYTICS_EVENTS.PRODUCT_CLICKED:
      eventName = "ppr-item-view-details";
      break;
    case ANALYTICS_EVENTS.CART_INIT:
      eventName = "ppr-cart-init";
      break;
    case ANALYTICS_EVENTS.ADD_TO_CART:
      eventName = "ppr-add-to-cart";
      break;
    case ANALYTICS_EVENTS.REMOVE_FROM_CART:
      eventName = "ppr-remove-from-cart";
      break;
    case ANALYTICS_EVENTS.VIEW_CART:
      eventName = "ppr-view-cart";
      break;
    case ANALYTICS_EVENTS.ORDER_PLACED:
      eventName = "ppr-order-placed";
      break;
    case ANALYTICS_EVENTS.ITEM_LIKED:
      eventName = "ppr-item-liked";
      break;
    case ANALYTICS_EVENTS.ITEM_UNLIKED:
      eventName = "ppr-item-unliked";
      break;
    case ANALYTICS_EVENTS.FEEDBACK_SUBMITTED:
      eventName = "ppr-feedback-submitted";
      break;
    case ANALYTICS_EVENTS.CHECKOUT_INIT:
      eventName = "ppr-checkout-init";
      break;
    case ANALYTICS_EVENTS.PROFILE_UPDATED:
      eventName = "ppr-profile-updated";
      break;
    case ANALYTICS_EVENTS.BANNER_CLICKED:
      eventName = "ppr-banner-clicked";
      break;
    case ANALYTICS_EVENTS.ADDRESS_SELECTED:
      eventName = "ppr-addr-selected";
      break;

    case ANALYTICS_EVENTS.PICKUP_STORE_SELECTED:
      eventName = "ppr-pickup-store-selected";
      break;
    case ANALYTICS_EVENTS.MULTIPLE_DELIVERY_STORES:
      eventName = "ppr-multi-del-store";
      break;
    case ANALYTICS_EVENTS.FILTER_APPLIED:
      eventName = "ppr-filter-applied";
      break;
    case ANALYTICS_EVENTS.SORT_APPLIED:
      eventName = "ppr-sort-applied";
      break;
    case ANALYTICS_EVENTS.ADD_MORE_ITEMS:
      eventName = "ppr-add-more-items";
      break;
    case ANALYTICS_EVENTS.VIEW_MORE_DESC:
      eventName = "ppr-view-more-desc";
      break;
    case ANALYTICS_EVENTS.SELECTED_PAYMENT_MODE:
      eventName = "ppr-selected-payment-mode";
      break;
    case ANALYTICS_EVENTS.SELECTED_DELIVERY_ADDRESS:
      eventName = "ppr-selected-delivery-address";
      break;
    case ANALYTICS_EVENTS.ADD_MONEY_CHECKOUT:
      eventName = "ppr-add-money-checkout";
      break;
    case ANALYTICS_EVENTS.LANDING_SCREEN_OPEN:
      eventName = "landing_screen_open";
      break;
    // case ANALYTICS_EVENTS.CATEGORY_DETAIL:
    //   eventName = "ppr-category-detail";
    //   break;
  }
  if (eventName.length > 0) {
    trackEvent(eventName, data);
  }
}

function setMixpanelIdentity(userBizInfo) {
  let properties = {
    $email: userBizInfo.email,
    balance: userBizInfo.balance,
    $name: userBizInfo.name,
    last_order_dt: userBizInfo.last_order_dt || "NA",
    cardNumber: userBizInfo.card_numbers[0] || "NA",
    total_order_value: userBizInfo.total_order_value,
    num_of_orders: userBizInfo.num_of_orders || "NA",
    days_since_last_order: userBizInfo.days_since_last_order || "NA",
    is_guest: userBizInfo?.is_guest_checkout,
  };

  selected_tokens.forEach((token) => {
    mixpanel[token].identify(userBizInfo.phone);
    mixpanel[token].people.set(properties);
  });
}

// function resetIdentity() {
//   selected_tokens.forEach((token) => {
//     mixpanel[token].reset();
//   });
// }

function trackEvent(event, params) {
  let eventData = {};

  if (params) {
    eventData = { ...eventData, ...params };
  }

  selected_tokens.forEach((token) => {
    mixpanel[token].track(event, eventData);
  });
}

const mixPanelService = {
  init,
  subscribe,
  unsubscribe,
};

export default mixPanelService;
